var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMailClassicLtr = function SvgMailClassicLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M84.437 20H15.563C12.498 20 10 22.472 10 25.506v48.988C10 77.528 12.498 80 15.563 80h68.874C87.502 80 90 77.528 90 74.494V25.506C90 22.472 87.502 20 84.437 20m-3.196 4.72h-62.08l30.763 22.93zm-66.473 2.672v47.102a.8.8 0 0 0 .795.786h68.874a.8.8 0 0 0 .795-.786V27.707L51.318 52.54a2.38 2.38 0 0 1-2.762.036l-.067-.048z",
    clipRule: "evenodd"
  })));
};
export default SvgMailClassicLtr;